import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

import { RTKQ_REDUCER_PATH } from './query.fn';

/**
 * The single shared RTK Query API instance for the whole app.
 *
 * Feature libraries attach their own endpoints with `baseApi.injectEndpoints(...)` (adding tag
 * types first via `baseApi.enhanceEndpoints({ addTagTypes })`), so the store only ever has to wire
 * up this ONE api's reducer + middleware — done once in `StoreManager`. No per-feature store changes.
 *
 * Every endpoint uses a per-endpoint `queryFn` so it can reuse the existing authenticated HTTP layer
 * (`@pressreader/services` / `@pressreader/content-api`) instead of an RTKQ `fetchBaseQuery`; hence the
 * shared base query is `fakeBaseQuery()` (a no-op that never runs).
 */
export const baseApi = createApi({
    reducerPath: RTKQ_REDUCER_PATH,
    baseQuery: fakeBaseQuery(),
    // Pinned explicitly (it is also the current RTKQ default). Optimistic `onQueryStarted` patches rely
    // on a tag invalidation that arrives while a request is in flight being DEFERRED until that request
    // settles, rather than refetching mid-flight. Flipping this to 'immediate' would let an invalidation
    // refetch read pre-edit data and clobber an in-flight optimistic update (see `savedSearchApi`'s
    // updateSavedSearch). Keep it 'delayed' so that guarantee can't regress on an RTKQ default change.
    invalidationBehavior: 'delayed',
    endpoints: () => ({}),
});
